<template>
  <page-status class="order-detail" :loading="loading">
    <van-cell-group>
      <van-cell>
        <cell-header slot="title" title="订单信息" />
      </van-cell>
      <van-cell title="投保人姓名">{{ detail.applicantName }}</van-cell>
      <van-cell title="投保人身份证号码">{{ detail.applicantCertNo }}</van-cell>
      <van-cell title="车牌号">{{
        detail.vehicleLicensePlateNo || '新车未上牌'
      }}</van-cell>
      <van-cell title="车架号">{{ detail.vinNo || '新车未上牌' }}</van-cell>
      <van-cell title="保费合计">{{ detail.sumPayFee }}元</van-cell>
    </van-cell-group>
    <div class="submit-action">
      <van-button class="submit-btn" block type="info" @click="onGoOrderDetail">
        下单
      </van-button>
    </div>

    <page-footer />
  </page-status>
</template>

<script>
import PageStatus from '@/components/PageStatus';
import CellHeader from '@/components/CellHeader';
import PageFooter from '@/components/PageFooter';
import * as services from '@/services';
import { Toast } from 'vant';

export default {
  name: 'NewOrder',
  components: {
    PageStatus,
    CellHeader,
    PageFooter,
  },

  data() {
    return {
      loading: true,
      detail: {
        orderDetailes: [],
      },
    };
  },

  created() {
    const token =
      this.$route.query.authToken || window.localStorage.getItem('authToken');
    window.localStorage.setItem('authToken', token);
    this.fetchData();
  },

  methods: {
    fetchData() {
      const { bizNo, bizType } = this.$route.query;
      const params = { bizNo, bizType };
      services
        .loadPayInfo(params)
        .then(res => {
          if (res.status === 'EXCEPTION') {
            Toast.fail(res.failCause);
            return;
          }
          if (res.content) {
            this.detail = res.content;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    onGoOrderDetail() {
      const { bizNo, bizType } = this.$route.query;
      const params = { bizNo, bizType };
      services.payApply(params).then(res => {
        if (res.status === 'EXCEPTION') {
          Toast.fail(res.failCause);
          return;
        }
        if (res.content) {
          const { cashierId } = res.content;
          this.$router.push({
            name: 'new-order-detail',
            query: { cashierId },
          });
        }
      });
    },
  },
};
</script>
<style lang="less">
.order-detail {
  .submit-action {
    margin: 32px 16px 0;
  }
}
</style>
